export const RepeatTemplatesSection = ({ handleDeleteTemplate, handleGenerateTemplate, repeatTemplates }) => {
  if (!repeatTemplates.length) {
    return null;
  }

  return (
    <section className="panel-surface space-y-4 px-5 py-5" data-testid="load-repeat-templates-section">
      <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-zinc-500">Repeat loads</p>
          <h2 className="mt-2 text-2xl font-semibold text-zinc-900">Repeat templates</h2>
        </div>
      </div>
      <div className="grid gap-4 lg:grid-cols-2" data-testid="repeat-template-grid">
        {repeatTemplates.map((template) => (
          <div className="rounded-3xl border border-zinc-200 bg-zinc-50 p-4" data-testid={`repeat-template-card-${template.id}`} key={template.id}>
            <p className="text-sm font-semibold text-zinc-900">{template.template_name}</p>
            <p className="mt-1 text-sm text-zinc-500">{template.customer_name} • Every {template.interval_days} day(s) • {template.copies_count} copy/copies</p>
            <p className="mt-1 text-xs text-zinc-500">Start {template.start_date}</p>
            <div className="mt-4 flex flex-wrap gap-2">
              <button className="rounded-2xl bg-zinc-900 px-4 py-2 text-sm font-semibold text-white" data-testid={`repeat-template-generate-${template.id}`} onClick={() => handleGenerateTemplate(template)} type="button">Create loads now</button>
              <button className="rounded-2xl border border-red-200 px-4 py-2 text-sm font-semibold text-red-600" data-testid={`repeat-template-delete-${template.id}`} onClick={() => handleDeleteTemplate(template)} type="button">Delete</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};